import * as React from 'react';
import { SVGProps } from 'react';

const IconThumbUpSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 14h2V6.09H2V14zm13-6.72c0-.7-.573-1.28-1.273-1.28H9.712l.604-3.454.02-.203a.958.958 0 0 0-.28-.675L9.38 1 5.37 5.74c-.235.23-.37.55-.37.9v6.08c0 .7.57 1.28 1.27 1.28h5.548c.528 0 .98-.322 1.171-.78l1.922-4.21A1.24 1.24 0 0 0 15 8.55V7.33h-.006L15 7.28z" />
  </svg>
);
export default IconThumbUpSizeS;
